import React from "react";
import InputComponent from "../../UI/InputComponent/InputComponent";
import Row from "../WrapperComponents/Row";
import Col from "../WrapperComponents/Col";
import Select from "react-virtualized-select";
import ColDynamic from "../WrapperComponents/ColDynamic";

const AddressDataShort = (props) => {
  const { countryList } = props.parentState;
  const { countyList } = props.parentState;
  const { cityAndMuncipalityList } = props.parentState.newFormData;
  const { districtList } = props.parentState.newFormData;
  const { sifDrzave, sifZupanije, sifGrdOpc } = props.address;

  const mappedCityAndMuncipalityList = cityAndMuncipalityList.map(
    (element) => element.gradoviOpcine[0]
  );

  const mappedDistrictList = districtList.map((element) => element.naselja[0]);

  const selectStyle = { borderColor: "red" };

  const disableCounty = sifDrzave ? false : true;
  const disableCity = sifZupanije ? false : true;
  const disableDistrict = sifGrdOpc ? false : true;

  return (
    <div className="form-group">
      <Row>
        <ColDynamic className="col-lg-4 mb-16">
          <>
            <label>Država{props.required && "*"}</label>
            <Select
              noResultsText={"Nema rezultata"}
              placeholder="Odaberi državu"
              options={countryList}
              onChange={(selectValue) =>
                props.autocompleteCountryHandler(selectValue, {
                  formGroup: "residencyAddress",
                  value: "sifDrzave",
                  code: "sifDrzave",
                  name: "nazivDrzave",
                })
              }
              labelKey="nazivKratki"
              valueKey="sifDrzave"
              value={props.address.sifDrzave}
            />
          </>
        </ColDynamic>
        <Col>
          {sifDrzave != "191" && sifDrzave !== "" ? (
            <InputComponent
              onChange={props.userInputHandler}
              objData={{ group: "residencyAddress" }}
              value={props.address.nazZupanije}
              id="nazZupanije"
              name="nazZupanije"
              controlLabel={"Naziv županije"}
            />
          ) : (
            <>
              <label>Naziv županije{props.required && "*"}</label>
              <Select
                noResultsText={"Nema rezultata"}
                style={
                  (props.required &&
                    props.parentState.error &&
                    props.address.sifZupanije.length < 1 &&
                    selectStyle) ||
                  null
                }
                placeholder="Odaberi županiju"
                disabled={disableCounty}
                options={countyList}
                onChange={(selectValue) =>
                  props.autocompleteCountyHandler(
                    selectValue,
                    {
                      formGroup: "residencyAddress",
                      value: "sifZupanije",
                      code: "sifZupanije",
                      name: "nazZupanije",
                    },
                    true
                  )
                }
                labelKey="nazZupanije"
                valueKey="sifZupanije"
                value={props.address.sifZupanije}
              />
            </>
          )}
        </Col>
      </Row>

      <Row>
        {sifDrzave != 191 && sifDrzave !== "" ? (
          <>
            <Col>
              <InputComponent
                onChange={props.userInputHandler}
                objData={{ group: "residencyAddress" }}
                value={props.address.nazGrdOpc}
                id="nazGrdOpc"
                name="nazGrdOpc"
                controlLabel={"Naziv grada-općine"}
              />
            </Col>
            <Col>
              <InputComponent
                required={props.required}
                style={
                  props.required &&
                  props.parentState.error &&
                  props.address.nazNaselja.length < 1 &&
                  "red"
                }
                onChange={props.userInputHandler}
                objData={{ group: "residencyAddress" }}
                value={props.address.nazNaselja}
                id="nazNaselja"
                name="nazNaselja"
                controlLabel={"Naziv mjesta"}
              />
            </Col>
          </>
        ) : (
          <>
            <ColDynamic className="col-lg-4 mb-16">
              <>
                <label>Naziv grada ili općine{props.required && "*"} </label>
                <Select
                  noResultsText={"Nema rezultata"}
                  style={
                    (props.required &&
                      props.parentState.error &&
                      props.address.sifGrdOpc.length < 1 &&
                      selectStyle) ||
                    null
                  }
                  placeholder="Odaberi grad ili općinu"
                  disabled={disableCity}
                  options={mappedCityAndMuncipalityList}
                  onChange={(selectValue) =>
                    props.autocompleteCityHandler(
                      selectValue,
                      {
                        formGroup: "residencyAddress",
                        value: "sifGrdOpc",
                        code: "sifGrdOpc",
                        name: "nazGrdOpc",
                      },
                      true
                    )
                  }
                  labelKey="nazGrdOpc"
                  valueKey="sifGrdOpc"
                  value={props.address.sifGrdOpc}
                />
              </>
            </ColDynamic>
            <Col>
              <>
                <label>Naziv mjesta{props.required && "*"} </label>
                <Select
                  noResultsText={"Nema rezultata"}
                  style={
                    (props.required &&
                      props.parentState.error &&
                      props.address.sifNaselja.length < 1 &&
                      selectStyle) ||
                    null
                  }
                  placeholder="Odaberi mjesto"
                  disabled={disableDistrict}
                  options={mappedDistrictList}
                  onChange={(selectValue) =>
                    props.autocompleteDistrictHandler(selectValue, {
                      formGroup: "residencyAddress",
                      value: "sifNaselja",
                      code: "sifNaselja",
                      name: "nazNaselja",
                    })
                  }
                  labelKey="nazNaselja"
                  valueKey="sifNaselja"
                  value={props.address.sifNaselja}
                />
              </>
            </Col>
          </>
        )}
      </Row>

      <Row>
        <Col>
          <InputComponent
            required={props.required}
            style={
              props.required &&
              props.parentState.error &&
              props.address.brPoste.length < 1 &&
              "red"
            }
            onChange={props.userInputHandler}
            objData={{ group: "residencyAddress" }}
            value={props.address.brPoste}
            id="brPoste"
            name="brPoste"
            controlLabel={"Poštanski broj"}
          />
        </Col>
        <Col>
          <InputComponent
            required={props.required}
            style={
              props.required &&
              props.parentState.error &&
              props.address.ulicaKbr.length < 1 &&
              "red"
            }
            onChange={props.userInputHandler}
            objData={{ group: "residencyAddress" }}
            value={props.address.ulicaKbr}
            id="ulicaKbr"
            name="ulicaKbr"
            controlLabel={"Ulica i kućni broj"}
          />
        </Col>
      </Row>
    </div>
  );
};

export default AddressDataShort;
